<div class="error-page">
    <h1>404: Not Found</h1>
    <p>You just hit a route that doesn't exist... the sadness.</p>
</div>